import { render, staticRenderFns } from "./ChangeRolePermissionForUser.vue?vue&type=template&id=420ec0ae"
import script from "./ChangeRolePermissionForUser.vue?vue&type=script&lang=js"
export * from "./ChangeRolePermissionForUser.vue?vue&type=script&lang=js"
import style0 from "./ChangeRolePermissionForUser.vue?vue&type=style&index=0&id=420ec0ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports